import { useAvailableSpace } from '../../utils/hooks/useAvailableSpace';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MeasuredCookieType, } from '../../Measured';
import { updateMeasuredCookie } from '../../Measured/redux/actions';
import { makeGetPrevLoadDims } from '../../Measured/redux/selectors';
export function useMeasuredStage(ref, shouldUpdateCookie, cookieType, cookieDim) {
    if (shouldUpdateCookie === void 0) { shouldUpdateCookie = true; }
    if (cookieType === void 0) { cookieType = MeasuredCookieType.DEVIATION_ARTSTAGE; }
    if (cookieDim === void 0) { cookieDim = 'both'; }
    var getPrevLoadDims = useMemo(function () { return makeGetPrevLoadDims(); }, []);
    var prevLoadDims = useSelector(function (state) {
        return getPrevLoadDims(state, cookieType, cookieDim);
    });
    var dispatch = useDispatch();
    var onResize = useCallback(function (_a) {
        var contentSize = _a.contentSize;
        if (contentSize && shouldUpdateCookie) {
            dispatch(updateMeasuredCookie(cookieType, cookieDim, contentSize)); // only the contentSize is important to save
        }
    }, [cookieDim, cookieType, dispatch, shouldUpdateCookie]);
    var sizes = useAvailableSpace(ref, onResize, { contentSize: prevLoadDims });
    return sizes;
}
//# sourceMappingURL=useMeasuredStage.js.map